module.exports = __webpack_public_path__ + "img/logo.286e946a.png";